import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { trackEvent } from "@/utils/analytics";

const FinalCta = () => (
  <section data-testid="final-cta-section" className="py-16 sm:py-24 lg:py-28">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <Reveal>
        <div className="relative overflow-hidden rounded-[2rem] bg-navy px-6 py-14 text-center sm:px-12 sm:py-20">
          <div className="bg-grid-faint pointer-events-none absolute inset-0 opacity-40" aria-hidden="true" />
          <div className="pointer-events-none absolute -top-24 left-1/2 h-64 w-[520px] -translate-x-1/2 rounded-full bg-brand/25 blur-[110px]" aria-hidden="true" />
          <div className="relative">
            <h2 className="mx-auto max-w-2xl text-balance text-3xl font-bold tracking-tight text-white sm:text-4xl">
              Prêt à reprendre le contrôle de votre activité ?
            </h2>
            <p className="mx-auto mt-4 max-w-xl text-base leading-relaxed text-white/60 sm:text-lg">
              Centralisez votre exploitation et pilotez votre entreprise avec ActiPilote.
            </p>
            <div className="mt-9 flex flex-col items-center justify-center gap-3 sm:flex-row">
              <Link to="/contact" onClick={() => trackEvent("click_demo", { location: "final_cta" })} data-testid="final-cta-button" className="group inline-flex w-full items-center justify-center gap-2 rounded-full bg-brand px-8 py-4 text-sm font-bold text-white transition-all duration-300 hover:-translate-y-0.5 hover:bg-brand-700 sm:w-auto">
                Commencer avec ActiPilote
                <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
              </Link>
              <a href="https://app.actipilote.com/login" data-testid="final-cta-login" className="inline-flex w-full items-center justify-center rounded-full border border-white/15 px-8 py-4 text-sm font-bold text-white transition-colors duration-300 hover:border-white/40 sm:w-auto">
                Se connecter
              </a>
            </div>
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);

export default FinalCta;
